import { v4 as uuidv4 } from 'uuid';
import { getStorage, ref, uploadString} from "firebase/storage";
import { doc, onSnapshot } from "firebase/firestore";
import { app, db } from './firebase'
import { Debug } from '../debugger';


// this function is used for loading state data for a published paywall (the published version of the paywall that is served in-app)
export const loadPaywall = async (id, completion) => {
	Debug("paywallServices", "loading paywall ...")
	const url = `https://superwall-public.superwall.me/paywalls/${id}.json`
	const response = await fetch(url)
	Debug("paywallServices", response.headers)
	const data = await response.json()
	Debug("paywallServices", "got paywall data ...")
    completion(data)
}

// this function publishes a paywall, fires the callback with the hosted url, and tries to open the URL in a new tab
export const publishPaywall = async (state, callback) => {
	Debug("paywallServices", "publishing paywall...")
	const data = JSON.stringify(state)
	const id = uuidv4()
	const storage = getStorage(app, "gs://superwall-public");;
	const storageRef = ref(storage, `paywalls/${id}.json`);
	uploadString(storageRef, data).then((snapshot) => {
		const url = window.location.origin + "?live=true&id=" + id
		// window.open(url, '_blank');
		callback(url)
	  });
}

// this function listens for changes to the given project and executes the callback whenever the dom needs to be reloaded
export const syncPaywall = async (projectId, callback) => {
	const docRef = doc(db, "projects", projectId)
	const unsub = onSnapshot(docRef, (doc) => {
    	const data = doc.data()

		console.log("Data Received:", data)

        callback(data)
	});
}

